import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKERS_LEGISLATIVE_BODIES = defineFcm('decision_makers_legislative_bodies')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		if (countryValue || localeValue) return localeValue && countryValue;
		return globalValue;
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'TBD',
		context: 'On the petition page DM section, controls whether that UI/UX is anchored around legislative bodies',
		description: 'When false, DM section uses current UI/UX without grouped DMs',
		mergeLogic: 'Displays a combined country & locale if either is set, otherwise global value is used',
		deprecated: 'No references found. Safe to delete after 2026-09-21.',
	});
